export const HomePageExplore = [
    {
        tag: 'Free',
        courses : [
            {
                heading : "Learn HTML",
                description : "This course covers the basic concepts of HTML including creating and structuring web pages, adding text, links, images, and more.",
                level : 'Beginner',
                lessionNumber : 6
            },
            {
                heading : "Learn CSS",
                description : "This course explores advanced topics in HTML5 and CSS3, including animations, transitions, and layout techniques",
                level : 'Beginner',
                lessionNumber : 6
            },
            {
                heading : "Responsive Web design",
                description : "This course teaches responsive web design techniques, allowing web pages to adapt to different devices and screen sizes",
                level : 'Beginner',
                lessionNumber : 6
            },
        ]
    },
    {
        tag: 'Most popular',
        courses : [
            {
                heading : "Java",
                description : "This course covers the fundamental concepts of Java, including object-oriented programming, data structures, algorithms, and more.",
                level : 'Beginner',
                lessionNumber : 6
            },
            {
                heading : "Python",
                description : "This course explores Python programming, focusing on syntax, data types, functions, libraries, and real-world applications.",
                level : 'Beginner',
                lessionNumber : 6
            },
            {
                heading : "C++",
                description : "This course covers the core concepts of C++, including object-oriented programming, memory management, algorithms, and data structures.",
                level : 'Beginner',
                lessionNumber : 6
            },
        ]
    },
    {
        tag: 'New to coding',
        courses : [
            {
                heading : "HTML",
                description : "This course covers the basic concepts of HTML including creating and structuring web pages, adding text, links, images, and more.",
                level : 'Beginner',
                lessionNumber : 6
            },
            {
                heading : "CSS",
                description : "This course explores advanced topics in HTML5 and CSS3, including animations, transitions, and layout techniques",
                level : 'Beginner',
                lessionNumber : 6
            },
            {
                heading : "Responsive ",
                description : "This course teaches responsive web design techniques, allowing web pages to adapt to different devices and screen sizes",
                level : 'Beginner',
                lessionNumber : 6
            },
        ]
    },
    
    {
        tag: 'Skills paths',
        courses : [
            {
                heading : "Flask",
                description : "This course introduces Flask, a lightweight web framework, covering routing, templates, database integration, and API creation.",
                level : 'Intermediate',
                lessionNumber : 16
            },
            {
                heading : "Django",
                description : "This course dives into Django, a high-level Python web framework, focusing on models, views, templates, and RESTful APIs.",
                level : 'Intermediate',
                lessionNumber : 16
            },
            {
                heading : "Fast API",
                description : "This course teaches FastAPI, a modern, fast web framework, emphasizing building APIs with automatic documentation and async support.",
                level : 'Intermediate',
                lessionNumber : 16
            },
        ]
    },
    {
        tag: 'Career paths',
        courses : [
            {
                heading : "Next.js",
                description : "This course explores Next.js, a React framework, focusing on server-side rendering, static site generation, and API routes.",
                level : 'Advance',
                lessionNumber : 30
            },
            {
                heading : "Nuxt.js",
                description : "This course covers Nuxt.js, a framework built on Vue.js, with a focus on server-side rendering, static site generation, and modular architecture.",
                level : 'Advance',
                lessionNumber : 30
            },
            {
                heading : "Sanity",
                description : "This course introduces Sanity, a headless CMS, teaching content modeling, API integration, and real-time content editing.",
                level : 'Advance',
                lessionNumber : 30
            },
        ]
    },
]